import { Sound } from "@pixi/sound";
import { Button } from "./ui/Button";
import { FederatedPointerEvent, IDestroyOptions, Texture } from "pixi.js";

export class DefaultButton extends Button {
    private readonly pressSound: Sound;

    public constructor(texture: Texture, pressSound?: Sound) {
        super({
            defaultTexture: texture
        });
        this.pressSound = pressSound;
        this.onUp.add(this.playSound, this);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.onUp.remove(this.playSound, this);
        super.destroy(options);
    }

    private playSound(_button: DefaultButton, _e: FederatedPointerEvent): void {
        this.pressSound?.play();
    }
}
